// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Q4c2p","question":"styles_question__2Xt_0","description":"styles_description__1hYRf"};